export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9024.5089de81.jpg";